import { cn } from "@/lib/utils";

export interface TabDef {
  id: string;
  label: string;
}

/**
 * A simple underline tab bar. Controlled — the parent owns the active id.
 */
export function Tabs({
  tabs,
  active,
  onChange
}: {
  tabs: TabDef[];
  active: string;
  onChange: (id: string) => void;
}): JSX.Element {
  return (
    <div role="tablist" className="flex gap-1 border-b border-border">
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={cn(
              "-mb-px border-b-2 px-4 py-2.5 text-sm font-medium transition-colors",
              isActive
                ? "border-accent text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground"
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
